import Children from '../../../../layouts/Children.vue';

const routes = [
  {
    path: 'warehouse',
    component: Children,

    children: [
      {
        path: '',
        name: 'warehouse',
        component: () => import('../pages/WarehouseDevicesPage.vue')
      }
    ]
  }
];

export default routes;
